"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestPhase = void 0;
const lodash_1 = require("lodash");
var TestPhase;
(function (TestPhase) {
    function isStudentAllowedtToSeeAnswers(testPhase) {
        return testPhase === 'review';
    }
    TestPhase.isStudentAllowedtToSeeAnswers = isStudentAllowedtToSeeAnswers;
    function isStudentAllowedToSubmitAnswers(testPhase) {
        return testPhase === 'started';
    }
    TestPhase.isStudentAllowedToSubmitAnswers = isStudentAllowedToSubmitAnswers;
    function isBefore(a, b) {
        return orderIndex(a) < orderIndex(b);
    }
    TestPhase.isBefore = isBefore;
    function isAfter(a, b) {
        return orderIndex(a) > orderIndex(b);
    }
    TestPhase.isAfter = isAfter;
    function orderIndex(testPhase) {
        return testPhaseOrder[testPhase] || 0;
    }
    TestPhase.orderIndex = orderIndex;
    function isLive(testPhase) {
        return (testPhase && liveTestPhases.includes(testPhase)) || false;
    }
    TestPhase.isLive = isLive;
    function order(phases, direction) {
        return (0, lodash_1.orderBy)(phases, (phase) => orderIndex(phase), direction);
    }
    TestPhase.order = order;
    function countPhases(phases) {
        return phases.reduce((accumulator, phase) => {
            accumulator[phase] += 1;
            return accumulator;
        }, {
            created: 0,
            started: 0,
            done: 0,
            closed: 0,
            review: 0,
        });
    }
    TestPhase.countPhases = countPhases;
    function numberOfUsers(total) {
        return (0, lodash_1.sum)((0, lodash_1.values)(total));
    }
    TestPhase.numberOfUsers = numberOfUsers;
    function numberOfUsersInTestPhases(total, phases) {
        return (0, lodash_1.sumBy)(phases, (phase) => (total && total[phase]) || 0);
    }
    TestPhase.numberOfUsersInTestPhases = numberOfUsersInTestPhases;
    function isAnyUserInTestPhase(total, phases) {
        return numberOfUsersInTestPhases(total, phases) > 0;
    }
    TestPhase.isAnyUserInTestPhase = isAnyUserInTestPhase;
    function isEveryUserInTestPhase(total, phase) {
        return numberOfUsers(total) === total[phase];
    }
    TestPhase.isEveryUserInTestPhase = isEveryUserInTestPhase;
    function phasesWithAnyUsers(total) {
        const entries = Object.entries(total);
        return (0, lodash_1.compact)(entries.map((kv) => (kv[1] > 0 ? kv[0] : undefined)));
    }
    TestPhase.phasesWithAnyUsers = phasesWithAnyUsers;
    /** returns the latest phase with any users */
    function latestTestPhase(total) {
        const phases = phasesWithAnyUsers(total);
        return (0, lodash_1.first)(order(phases, 'desc'));
    }
    TestPhase.latestTestPhase = latestTestPhase;
    /** returns the earliest phase with any users */
    function earliestTestPhase(total) {
        const phases = phasesWithAnyUsers(total);
        return (0, lodash_1.first)(order(phases, 'asc'));
    }
    TestPhase.earliestTestPhase = earliestTestPhase;
    function isTestReopened(counts) {
        return isAnyUserInTestPhase(counts, ['closed', 'review']) && isAnyUserInTestPhase(counts, ['created', 'started']);
    }
    TestPhase.isTestReopened = isTestReopened;
})(TestPhase || (exports.TestPhase = TestPhase = {}));
const liveTestPhases = ['created', 'started', 'done'];
const testPhaseOrder = {
    created: 0,
    started: 1,
    done: 2,
    closed: 3,
    review: 4,
};
//# sourceMappingURL=TestPhase.js.map